"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUserScheduledToBeOnLunch = void 0;
const is_date_in_schedule_item_1 = require("./is-date-in-schedule-item");
function isUserScheduledToBeOnLunch(shifts, date) {
    return shifts.some(shift => shift.lunch_breaks.some(lunchBreak => (0, is_date_in_schedule_item_1.isDateInScheduleItem)(lunchBreak, date)));
}
exports.isUserScheduledToBeOnLunch = isUserScheduledToBeOnLunch;
